import useHttpPost from 'states/generics/useHttpPost'
import { computed } from '@vue/composition-api'
import Store from '@/store'

export default function useStartupFollow({ startupId }) {
  const startUrl = `/startups/${startupId}/start-following`
  const stopUrl = `/startups/${startupId}/stop-following`

  const { postInProgress: startInProgress, post: startFollowingPost } =
    useHttpPost({
      url: startUrl,
      sleep: 250,
    })
  const startFollowing = () => {
    const newFollowsCount = Store.state.startupList.followedCount + 1
    Store.commit('startupList/SET_FOLLOWS_COUNT', newFollowsCount)
    return startFollowingPost()
  }

  const { postInProgress: stopInProgress, post: stopFollowingPost } =
    useHttpPost({
      url: stopUrl,
      sleep: 250,
    })
  const stopFollowing = () => {
    const newFollowsCount = Store.state.startupList.followedCount - 1
    Store.commit('startupList/SET_FOLLOWS_COUNT', newFollowsCount)
    return stopFollowingPost()
  }

  const isFollowingInProgress = computed(() => {
    return startInProgress.value || stopInProgress.value
  })

  return {
    startFollowing,
    stopFollowing,
    isFollowingInProgress,
  }
}
